enum AccessLevel {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  USER = 'USER',
  MEMBER = 'MEMBER',
  COACH = 'COACH',
}

export default AccessLevel;
